import AbstractInstaller from "../../core/application/AbstractInstaller";
import SkinKeyRegistry from "../../core/ui/SkinKeyRegistry";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";
import PlayDecisionDialogCommand from "./controller/PlayDecisionDialogCommand";
import DecisionScreenMediator from "./view/DecisionScreenMediator";

export default class DecisionInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        SkinKeyRegistry.DECISION_SCREEN_SKIN = this._mapMediator(DecisionScreenMediator, lib.MainAssets.DecisionScreenSkin);

        commands.add(ScenarioPlayerEvent.PUSH_DECISION_DIALOG_AVAILABLE, PlayDecisionDialogCommand);
    }
}